import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserApplicationsActivity } from '../../../store/actions';
import { buildPaginationData } from '../../../utility/utils';
import OptionalPagination from '../../pagination/OptionalPagination';
import { Card, CardContent } from "../../ui/card";
import ApplicationsEventsTable from '../../tables/ApplicationsEventsTable';

const Applications = ({ userId, history }) => {
  const dispatch = useDispatch();
  const [ filter ] = useState(null);
  const [ sortBy, setSortBy ] = useState(null);
  const [ paginationData, setPaginationData ] = useState(null);
  const { loading, userAppsActivity } = useSelector((state) => state.Applications);

  const fetchData = (page) => {
    let queryParams = {};

    if (page) {
      queryParams.page = page;
    }

    if (sortBy) {
      queryParams.sort_by = sortBy;
    }

    if (filter) {
      queryParams = {...queryParams, ...filter};
    }

    dispatch(getUserApplicationsActivity(userId, queryParams));
  };

  const onTableSortChange = (sortBy) => {
    if (sortBy) {
      setSortBy(sortBy);
      fetchData();
    }
  };

  const navigateToPage = (page) => {
    fetchData(page);
  };

  useEffect(() => {
    if (userAppsActivity?.recentActivities?.length > 0) {
      setPaginationData(buildPaginationData(userAppsActivity));
    }
  }, [userAppsActivity]);

  useEffect(() => {
    if (userId && !userAppsActivity?.recentActivities?.length) {
      dispatch(getUserApplicationsActivity(userId));
    }
  }, [userId])

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="mb-4 flex justify-between items-center">
          <h3 className="font-semibold text-lg">
            Log Entries
          </h3>
        </div>
        <div className="overflow-x-auto">
          <ApplicationsEventsTable
            fetch={fetchData}
            data={userAppsActivity?.recentActivities}
            isLoading={loading}
            onSortChange={onTableSortChange}
            disableSortBy
          />
          <OptionalPagination
            items={userAppsActivity?.recentActivities}
            paginationData={paginationData}
            navigateTo={navigateToPage}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default Applications;
